import { AdtSplashLogo } from './AdtSplashLogo'
import { readShellDocumentTheme } from './shellDocumentTheme'
import { useDismissStaticShellSplash } from './useDismissStaticShellSplash'

export function ShellSplash() {
  useDismissStaticShellSplash()
  const theme = readShellDocumentTheme()

  return (
    <div
      className="shell-splash"
      data-testid="shell-splash"
      data-shell-splash-theme={theme}
    >
      <AdtSplashLogo
        size={120}
        className="shell-splash__logo"
        clipPathId="adt-splash-clip-react"
        fill="var(--color-logo-splash, #ffffff)"
      />
    </div>
  )
}
